/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Start_Times_RequiredInputs */

const vi_error_irrigation_schedule_start_times_required = /** @type {(inputs: Error_Irrigation_Schedule_Start_Times_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm ít nhất một giờ bắt đầu`)
};

/**

* @param {Error_Irrigation_Schedule_Start_Times_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_start_times_required = /** @type {((inputs?: Error_Irrigation_Schedule_Start_Times_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Start_Times_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_start_times_required(inputs)
});